export default {
  amountMustNotExceedCurrentOrderAmount:
    "يجب ألا يتجاوز المبلغ المبلغ الحالي للطلب",
  clipboardCopyMessage: "تم نسخ الرقم إلى الحافظة",
  deliveryTime: "موعد التسليم",
  driver: "السائق",
  hideHistory: "إخفاء السجل",
  newLocation: "الموقع الجديد",
  receiver: "اسم المتلقي",
  reportProblem: "الابلاغ عن مشكلة",
  showHistory: "عرض السجل",
  singleOrderTracking: "متابعة الطلب",
  trackOrder: "تتبع الطلب",
};
